<template>
  <section id="contact" class="py-16 md:py-24 bg-white">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-16">
        <h2 class="text-[clamp(1.5rem,3vw,2.5rem)] font-bold text-neutral-700 mb-4">
          联系我们
        </h2>
        <p class="text-neutral-500 max-w-2xl mx-auto text-lg">
          无论您有任何问题或需求，我们都很乐意听取您的意见并为您提供帮助
        </p>
      </div>

      <div class="flex flex-col lg:flex-row">
        <div class="lg:w-1/2 mb-10 lg:mb-0 lg:pr-10">
          <div class="bg-neutral-100 rounded-xl p-8 shadow-lg">
            <h3 class="text-xl font-bold text-neutral-700 mb-6">发送消息</h3>
            <form @submit.prevent="handleSubmit">
              <div class="mb-6">
                <label for="name" class="block text-neutral-700 font-medium mb-2">姓名</label>
                <input
                    type="text"
                    id="name"
                    v-model="formData.name"
                    class="w-full px-4 py-3 rounded-lg border border-neutral-300 focus:border-primary focus:ring focus:ring-primary/20 outline-none transition-all duration-200"
                    placeholder="请输入您的姓名"
                >
              </div>
              <div class="mb-6">
                <label for="email" class="block text-neutral-700 font-medium mb-2">邮箱</label>
                <input
                    type="email"
                    id="email"
                    v-model="formData.email"
                    class="w-full px-4 py-3 rounded-lg border border-neutral-300 focus:border-primary focus:ring focus:ring-primary/20 outline-none transition-all duration-200"
                    placeholder="请输入您的邮箱"
                >
              </div>
              <div class="mb-6">
                <label for="subject" class="block text-neutral-700 font-medium mb-2">主题</label>
                <input
                    type="text"
                    id="subject"
                    v-model="formData.subject"
                    class="w-full px-4 py-3 rounded-lg border border-neutral-300 focus:border-primary focus:ring focus:ring-primary/20 outline-none transition-all duration-200"
                    placeholder="请输入消息主题"
                >
              </div>
              <div class="mb-6">
                <label for="message" class="block text-neutral-700 font-medium mb-2">消息</label>
                <textarea
                    id="message"
                    rows="5"
                    v-model="formData.message"
                    class="w-full px-4 py-3 rounded-lg border border-neutral-300 focus:border-primary focus:ring focus:ring-primary/20 outline-none transition-all duration-200 resize-none"
                    placeholder="请输入您的消息"
                ></textarea>
              </div>
              <button
                  type="submit" style="color:#E6733A"
                  class="w-full px-6 py-3 bg-primary hover:bg-primary/90 text-white font-medium rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
              >
                发送消息
              </button>
            </form>
          </div>
        </div>
        <div class="lg:w-1/2">
          <div class="bg-neutral-100 rounded-xl p-8 shadow-lg">
            <h3 class="text-xl font-bold mb-6">联系方式</h3>
            <div class="space-y-6">
              <div class="flex items-start">
                <div class="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center mr-4">
                  <i class="fa fa-map-marker text-xl"></i>
                </div>
                <div>
                  <h4 class="font-bold mb-1">地址</h4>
                  <p class="opacity-90">上海市虹口区吴淞路575号907室</p>
                </div>
              </div>
              <div class="flex items-start">
                <div class="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center mr-4">
                  <i class="fa fa-envelope text-xl"></i>
                </div>
                <div>
                  <h4 class="font-bold mb-1">邮箱</h4>
                  <p class="opacity-90">business@forlawtech.com</p>
                </div>
              </div>
              <div class="flex items-start">
                <div class="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center mr-4">
                  <i class="fa fa-clock-o text-xl"></i>
                </div>
                <div>
                  <h4 class="font-bold mb-1">工作时间</h4>
                  <p class="opacity-90">周一至周五: 9:00 - 18:00</p>
                </div>
              </div>
            </div>

<!--            <div class="mt-8">-->
<!--              <h4 class="font-bold mb-4">关注我们</h4>-->
<!--              <div class="flex space-x-4">-->
<!--                <a href="#" class="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors duration-200">-->
<!--                  <i class="fa fa-weixin text-xl"></i>-->
<!--                </a>-->
<!--                <a href="#" class="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors duration-200">-->
<!--                  <i class="fa fa-weibo text-xl"></i>-->
<!--                </a>-->
<!--                <a href="#" class="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors duration-200">-->
<!--                  <i class="fa fa-linkedin text-xl"></i>-->
<!--                </a>-->
<!--                <a href="#" class="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors duration-200">-->
<!--                  <i class="fa fa-github text-xl"></i>-->
<!--                </a>-->
<!--              </div>-->
          </div>

<!--          <div class="bg-neutral-100 rounded-xl p-8 shadow-lg">-->
<!--            <h3 class="text-xl font-bold text-neutral-700 mb-6">常见问题</h3>-->
<!--            <div class="space-y-4">-->
<!--              <div class="border-b border-neutral-200 pb-4" v-for="(faq, index) in faqs" :key="index">-->
<!--                <button-->
<!--                    class="flex justify-between items-center w-full text-left font-medium text-neutral-700 focus:outline-none"-->
<!--                    @click="toggleFaq(index)"-->
<!--                >-->
<!--                  <span>{{ faq.question }}</span>-->
<!--                  <i class="fa fa-chevron-down text-primary transition-transform duration-200" :style="{ transform: faq.open ? 'rotate(180deg)' : 'rotate(0deg)' }"></i>-->
<!--                </button>-->
<!--                <div-->
<!--                    class="mt-2 text-neutral-500"-->
<!--                    v-if="faq.open"-->
<!--                >-->
<!--                  {{ faq.answer }}-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'Contact',
    data() {
      return {
        formData: {
          name: '',
          email: '',
          subject: '',
          message: ''
        },
        faqs: [
          {
            question: '你们的服务流程是怎样的？',
            answer: '我们的服务流程通常包括需求分析、方案设计、项目开发、测试验收和售后服务五个阶段。我们会在每个阶段与客户保持密切沟通，确保项目顺利进行。',
            open: true
          },
          {
            question: '项目需要多长时间才能完成？',
            answer: '项目的完成时间取决于项目的规模和复杂度。我们会在项目开始前进行详细的评估，并与客户协商确定合理的项目周期。一般来说，小型项目可能需要2-4周，中型项目需要1-3个月，大型项目则需要3个月以上。',
            open: false
          },
          {
            question: '如何确定项目的报价？',
            answer: '我们会根据项目的需求、功能复杂度、技术难度、开发周期等因素进行综合评估，然后给出一个详细的报价。我们的报价是透明的，不包含任何隐藏费用。',
            open: false
          },
          {
            question: '你们提供售后服务吗？',
            answer: '是的，我们提供全面的售后服务，包括系统维护、故障排除、功能升级等。我们的售后服务团队会在项目交付后提供一定期限的免费维护，之后也可以根据客户的需求提供长期的技术支持服务。',
            open: false
          }
        ]
      }
    },
    methods: {
      handleSubmit() {
        // 这里可以添加表单提交逻辑
        if(this.formData.message && this.formData.name && this.formData.email){
          alert('消息已发送！我们会尽快回复您。');
        }
        this.formData = {
          name: '',
          email: '',
          subject: '',
          message: ''
        };
      },
      toggleFaq(index) {
        this.faqs.forEach((faq, i) => {
          if (i === index) {
            faq.open = !faq.open;
          } else {
            faq.open = false;
          }
        });
      }
    }
  }
</script>
